import React from 'react'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import { useTranslation } from '../../hooks/useTranslation'
import { Page } from '~/components/_layouts'
import { DashboardHeader } from './Header'
import { Solo } from './programs/Solo'
import { SoloPlus } from './programs/SoloPlus'
import { Flex } from './programs/Flex'
import { Premium } from './programs/Premium'
import { Select } from './programs/Select'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Reminders from './Reminders'
import { DashboardProvider, useDashboard } from './DashboardProvider'
import BenefitsProvider from '../coach_services/BenefitsProvider'
import { ActionPlanProvider } from '../ActionPlan/ActionPlanProvider'
import { Provider } from 'react-redux'
import { store } from '../../lib/store'
import { setProgressPercent } from '../ActionPlan/ActionPlanSlice'
import { Toaster } from '~/lib/ui/toast'

const Index = ({ ...props }) => {
  return (
    <DashboardProvider {...props}>
      <Provider store={store}>
        <ActionPlanProvider {...props}>
          <TranslationProvider
            locale={props.current_user.locale}
            translations={translations}
            scope="javascript.components.home"
          >
            <Dashboard {...props} />
          </TranslationProvider>
        </ActionPlanProvider>
      </Provider>
    </DashboardProvider>
  )
}
export default Index

const Dashboard = ({
  current_user,
  coach,
  calendly_events_path,
  service_requests,
  coach_calendly_link,
  resume_review,
  resume_revisions,
}) => {
  const queryClient = new QueryClient()
  const { onlyReminders } = useDashboard()
  const { t } = useTranslation()

  const getPageVariant = () => {
    if (current_user.select) return 'select-light'
    if (current_user.gold) return 'secondary'
    return 'primary'
  }

  // const inChatFrame = parent.document.getElementById('chat_browse') !== null
  const { userProgress } = useDashboard()
  store.dispatch(setProgressPercent(userProgress))

  return (
    <BenefitsProvider
      current_user={current_user}
      coach={{ ...coach, calendly_link: coach_calendly_link }}
      calendly_events_path={calendly_events_path}
      service_requests={service_requests}
      resume_review={resume_review}
      resume_revisions={resume_revisions}
    >
      {onlyReminders && <Reminders />}
      {!onlyReminders && (
        <QueryClientProvider client={queryClient}>
          <Page
            variant={getPageVariant()}
            title={t('title')}
            header={<DashboardHeader current_user={current_user} />}
            rightDrawer={{
              title: t('reminders.title'),
              viewActionText: t('view_reminders'),
              children: <Reminders />,
            }}
          >
            <Toaster />
            {current_user.trial && <Solo current_user={current_user} />}
            {current_user.bronze && <Solo current_user={current_user} />}
            {current_user.solo_plus && <SoloPlus current_user={current_user} />}
            {current_user.silver && <Flex current_user={current_user} />}
            {current_user.gold && <Premium current_user={current_user} />}
            {current_user.select && <Select current_user={current_user} />}
          </Page>
        </QueryClientProvider>
      )}
    </BenefitsProvider>
  )
}
